import { Col, InputField, Label, ReactSelectBox, Row, SwitchToggle } from 'client/CommonComponents';
import './Planned.scss'
import { formatPrice, isNumber, isNumberWithOneDecimal } from 'utils'
import { CONSTANTS } from 'client/utils/constants';
import AssetNumber from 'client/Components/OrderManagement/AssetNumber/AssetNumber-Container';

const Planned = (props: any) => {

    const reason = props.reason;
    const onClickPlannedMilaegeHourMeter = props.onClickPlannedMilaegeHourMeter;
    const onClickPlannedCondition = props.onClickPlannedCondition;
    const onClickPlannedStatus = props.onClickPlannedStatus;
    const onClickPlannedComments = props.onClickPlannedComments;
    const conditionDropDownList = props.conditionDropDownList;
    const statusDropDownList = props.statusDropDownList;        
    const milaegeHourMeterFormat = props.milaegeHourMeterFormat;
    const onClickReason = props.onClickReason;
    const onClickAnticipatedDisposalPrice = props.onClickAnticipatedDisposalPrice;
    const anticipatedDisposalPriceFormat = props.anticipatedDisposalPriceFormat;
    const requestType = props.requestType;
    const onChangeQuotePrice = props.onChangeQuotePrice;
    const setAssetChangeReason = props?.setAssetChangeReason;
    const assetChangeReason = props?.assetChangeReason;
    const OnBlurOfFields = props?.OnBlurOfFields

    return (<>
        <Col xs={12} sm={4} md={4} lg={4} className='mt-0 mb-3'>
            <AssetNumber order = {reason} setAssetChangeReason = {setAssetChangeReason} type={CONSTANTS?.REQUISITION} assetChangeReason = {assetChangeReason}/>
        </Col>
        <Row className='mx-0 px-0'>
            <Col xs={12} sm={12} md={12} lg={12} className='mb-3'>
                <Label data-attribute="Planned_Default_Label">Asset Information</Label>
                <div className='planned-readonly-field'>
                    <div className='labelValue'>
                        <Label data-attribute="Planned_Default_Label_2">Unit#</Label>
                        <span>{reason?.unitNumber || "-"}</span>
                    </div>
                    <div className='labelValue'>
                        <Label data-attribute="Planned_Default_Label_3">Description</Label>
                        <span>{reason?.description || "-"}</span>
                    </div>
                    <div className='labelValue'>
                        <Label data-attribute="Planned_Default_Label_4">Year</Label>
                        <span>{reason?.modelYear || "-"}</span>
                    </div>
                    <div className='labelValue NetBookedValue'>
                        <Label data-attribute="Planned_Default_Label_5">Net Booked Value</Label>
                        <span>{(reason?.netBookedValue !== null && reason?.netBookedValue !== "" && reason?.netBookedValue !== undefined) ? `$${formatPrice(reason?.netBookedValue, 2)}` : "-"}</span>
                    </div>
                                                                                     <div className='labelValue'>
                        <Label data-attribute="Planned_Default_Label_5_1">E1 Disposal Date</Label>
                        <span>{reason?.replacementAssetDisposalDate || "-"}</span>
                    </div>
                </div>
            </Col>
            {!reason?.replacementAssetDisposalDate && (
            <>
                <Col xs={12} sm={4} md={4} lg={4} className='mb-3'>
                    <Label required data-attribute="Planned_Default_Label_6">Mileage</Label>
                    <InputField
                        placeholder='Mileage'
                        name='milaegeHourMeter'
                        value={reason.mileageHourMeter}
                        onChange={(item: any, e: any) => onClickPlannedMilaegeHourMeter(e, item, reason)}
                        onBlur={(event: any) => milaegeHourMeterFormat(event, reason)}
                        onKeyPress={(event: any) => { isNumberWithOneDecimal(event) }}
                        className={reason.mileageHourMeterError ? 'controlValidation' : ''}
                     data-attribute="Planned_milaegeHourMeter_Input" />
                    {reason.mileageHourMeterError ? <p className='validMessage'>{reason.mileageHourMeterError}</p> : null}
                </Col>
                <Col xs={12} sm={4} md={4} lg={4} className='mb-3'>
                    <Label required data-attribute="Planned_Default_Label_7">Condition</Label>
                    <ReactSelectBox
                        options={conditionDropDownList}
                        onChange={(item: any, e: any) => onClickPlannedCondition(e, item, reason)}
                        name='condition'
                        value={reason.condition == "" ? { label: "Select Condition", text: "" } : { label: reason.condition, text: reason.condition }}
                        className={reason.conditionError ? 'controlValidation' : ''}
                     data-attribute="Planned_condition_SearchSelectBox" />
                    {reason.conditionError ? <p className='validMessage'>{reason.conditionError}</p> : null}
                </Col>
                {reason?.reasonType != CONSTANTS.REASON_PLANNED ?
                    <Col xs={12} sm={4} md={4} lg={4} className='mb-3'>
                        <Label required data-attribute="Planned_Default_Label_8">Reason</Label>
                        <InputField
                            placeholder='Reason'
                            name='reason'
                            onBlur={() => OnBlurOfFields(reason)}
                            value={reason.reason}
                            onChange={(item: any, e: any) => onClickReason(e, item, reason)}
                            className={reason.reasonError ? 'controlValidation' : ''}
                         data-attribute="Planned_reason_Input" />
                        {reason.reasonError ? <p className='validMessage'>{reason.reasonError}</p> : null}
                    </Col> : null}
                <Col xs={12} sm={4} md={4} lg={4} className='mb-3'>
                    <Label data-attribute="Planned_Default_Label_9">Status</Label>
                    <ReactSelectBox
                        options={statusDropDownList}
                        onChange={(item: any, e: any) => onClickPlannedStatus(e, item, reason)}
                        name='status'
                        value={reason.status == "" ? { label: "Select Status", text: "" } : { label: reason.status, text: reason.status }}
                     data-attribute="Planned_status_SearchSelectBox" />
                </Col>
                <Col xs={12} sm={4} md={4} lg={4} className='mb-3 anticipated-value'>
                    <Label required={reason?.status != "" && reason?.status != "Select Status"} data-attribute="Planned_Default_Label_10">Anticipated Disposal Price</Label>
                    <InputField
                        placeholder='Anticipated Disposal Price'
                        name='anticipatedDisposalPrice'
                        value={reason.anticipatedDisposalPrice}
                        prefix={"$"}
                        onChange={(item: any, e: any) => onClickAnticipatedDisposalPrice(e, item, reason)}
                        onBlur={(event: any) => anticipatedDisposalPriceFormat(event, reason)}
                        onKeyPress={(event: any) => { isNumber(event) }}
                        className={((reason.anticipatedDisposalPriceError && reason?.status != "" && reason?.status != "Select Status") || (reason?.anticipatedDisposalPriceLengthError)) ? 'controlValidation' : ''}
                     data-attribute="Planned_anticipatedDisposalPrice_Input" />
                    {((reason.anticipatedDisposalPriceError && reason?.status != "" && reason?.status != "Select Status") || (reason?.anticipatedDisposalPriceLengthError))? <p className='validMessage'>{reason.anticipatedDisposalPriceError == "" ? reason?.anticipatedDisposalPriceLengthError : reason.anticipatedDisposalPriceError}</p> : null}
                </Col>
                {
                    requestType == CONSTANTS.PRODUCTION_VEHICLE || requestType == CONSTANTS.MANAGEMENT_VEHICLE ?
                    <Col xs={12} sm={4} md={4} lg={4} className='mb-sm-3 mb-2'> 
                    <Label data-attribute="Planned_Default_Label_11">Quote Price</Label>       
                        <SwitchToggle className='mt-sm-3' checked={reason?.showQuotePrice} onChange={(item: any, e: any) =>onChangeQuotePrice(e, item, reason)} data-attribute="Planned_Default_SwitchToggle" />
                    </Col> : '' 
                }
            </>
            )}
        </Row>
        {
                <Row className='mx-0 px-0'>
                    <Col xs={12} sm={12} md={12} lg={12} className='mb-3 comment-block'>
                        <Label data-attribute="Planned_Default_Label_12">Comment</Label>
                        <InputField
                            placeholder='Comment'
                            name='comment'
                            value={reason.comments}
                            onBlur={() => OnBlurOfFields(reason)}
                            onChange={(item: any, e: any) => onClickPlannedComments(e, item, reason)}
                            multiline={true}
                            resizable={false}
                            row={2}
                         data-attribute="Planned_comment_Input" />
                        {reason.commentsError ? <p className='validMessage'>{reason.commentsError}</p> : null}
                    </Col>
                </Row> 
        }
    </>)
}



export default Planned;